module.exports = __webpack_public_path__ + "static/SS-logo-white-f46b05a272f74ba69a9805d31cb213a3.png";